import { motion } from 'motion/react';
import IconArrow from './IconArrow';
import { useAppStore } from '../stores/useAppStore';

function MenuButton({ item, onClick }) {
  const { menuActiveKey } = useAppStore();
  const isActive = menuActiveKey === item.key;

  return (
    <motion.div
        onClick={onClick}
        className={`
            click-effect
            block
            inset-0
            w-full
            rounded-r-full
            p-[0.25rem] /* Espacio para que se vea el borde */
            pl-0
            ${isActive 
                ? "bg-gradient-animated touch-none pointer-events-none"  /* Activo */
                : "bg-silver"
             }
            `
          }>
            <div className='
                relative
                h-[8.375rem]
                w-full
                bg-[#0B1931]
                flex
                flex-col
                justify-center
                rounded-r-full
                pl-12
                pr-[6rem]
                '
            >
                  <div className='font-normal
                  text-[2rem]
                  leading-[2.5rem]' dangerouslySetInnerHTML={{__html:item.title}}></div>
                  {item.subtitle &&
                  <div className='font-extralight text-[1.5rem]'>{item.subtitle}</div>
                }


                <IconArrow className="w-8 h-8 absolute right-58u top-1/2 -translate-y-1/2" />

            </div>
    </motion.div>
  );
}

export default MenuButton;